<template>
<div class="wrapper">
    <div class="container">

        <div class="forgot-password q-py-xl q-px-lg">
            <h4 class="q-mb-lg">Forgot your password?</h4>
            <p class="q-my-lg">Enter your Email below and we will send a message to reset your password</p>
            <input type="email" v-html="error_email" class="email q-my-sm" v-model="username" placeholder="Email">
            <p v-if="is_email_error" class="text-negative">* Please enter a valid email id</p>
            <p v-if="is_email_valid" class="text-positive">* Email id is valid</p>
            <input type="submit" class="submit q-my-sm" @click="send_confirmation_code()" value="Reset my password">

        </div>


    </div>

</div>

</template>
<script>
import awsconfig from "../aws-exports";
import { Auth } from "aws-amplify";
Auth.configure(awsconfig);
export default {
    data() {
        return{
            username:"",
            is_email_valid:false,
            is_email_error:false,

        }

        
    },

    computed:{

        error_email(){
            var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

     

      if(regex.test(this.username))
      {
        this.is_email_valid = true;
        this.is_email_error = false;
        
        return '';


      }
      else if(this.username.length <4){
        this.is_email_valid = false;
        this.is_email_error = false;
        
        return '';

      }
      else
      {
        this.is_email_valid = false;
        this.is_email_error = true;
        return "";

      }

        }

    },

    methods:{

        async send_confirmation_code(){

            if(!this.is_email_valid)
            {
                this.$alert('please enter correct email id and try again','Could not reset','error');
                return;

            }

             this.$q.loading.show({
          message: 'Submitting your request, please wait..'
          
        });
            // Send confirmation code to user's email
                Auth.forgotPassword(this.username)
                .then(data => {


                    this.$q.loading.hide();

                    this.$store.dispatch("setForgotPasswordEmail", this.username);

                    this.$router.push({
                    name: "EnterPassword",
                    });


                    
                    console.log(data)
                    
                    })
                .catch(err => {
                     this.$q.loading.hide();
                    
                    this.$alert("Could not submit query, some error has occured !","Sorry", "error");

                    console.log(err);
                    return;
                    
                });

        }

    }
}
</script>

<style scoped>


    .wrapper{
        height: 89.2vh;
    }
    .container{
        height: 100%;
        display:flex;
        justify-content: center;
        align-items:center;
    }
    .forgot-password{
        width:400px;
        height:400px;
        box-shadow: 0 5px 15px rgba(0,0,0,.5);
        

    }

    .forgot-password input{
        width: 100%;
        height: 36px;
         border-radius: 4px;
         outline:none
         
    }

    .forgot-password .email{
        border:1.5px solid #d0d0d0;
        padding-left:10px;
        border-bottom: 1px solid #ccc !important;
    }
    .forgot-password .submit{
        background-color: #175293;
        border: none;
        color: white;
        cursor: pointer;
       
    }

    .forgot-password .submit:hover{
        background-color: #073a70;
        
    }


</style>